import * as type from '../actions/types';
import { getData } from '../models/Integrations';

const initialState = {
  data: [],
  error: '',
  pending: false,
  success: false,
  facebookPixel: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_OBEE_INTEGRATIONS_PENDING: {
      return {
        ...initialState,
        pending: true,
      };
    }

    case type.FETCH_OBEE_INTEGRATIONS_SUCCESS: {
      return {
        ...state,
        data: action.payload.data?.map(getData),
        pending: false,
        success: true,
      };
    }

    case type.FETCH_OBEE_INTEGRATIONS_FAILURE: {
      return {
        ...state,
        pending: false,
        error: action.payload,
      };
    }

    case type.INITIALIZE_FACEBOOK_PIXEL: {
      return {
        ...state,
        facebookPixel: action.payload.data,
      };
    }

    default: {
      return state;
    }
  }
};
